// Module
var code = "<div class=\"tags-viewer-drv\">\n    <tag ng-repeat=\"tag in tags\" ng-click=\"add(tag)\" ng-class=\"{selected: tag.selected}\">\n        <span class=\"box text\">{{ displayKey ? tag[displayKey] : tag }}</span>\n        <span class=\"box plus\">+</span>\n    </tag>\n</div>";
// Exports
module.exports = code;